import type { OnAcceptanceFields } from '@/hooks/rest/types';
import useGetUserAgreements from '@/hooks/rest/useGetUserAgreement';
import usePostUserAgreement from '@/hooks/rest/usePostUserAgreement';
import { useContext, useState } from 'react';

import { PatientConsentContext } from '@/context/PatientConsentProvider';
import { PatientConsent } from '../common/Consent/PatientConsent';
import PrivacyPolicyDialog from '../common/PrivacyPolicy/PrivacyPolicyDialog';

export const Notices = () => {
  const [patientConsentSubmitted, setPatientConsentSubmitted] = useState<boolean>(false);
  const { loading, hasPrivacyPolicyAgreement, setAgreements } = useGetUserAgreements();
  const { makeRequest: acceptUserAgreement } = usePostUserAgreement();
  const { requiresConsentSubmission, isLoadingConsentStatus } = useContext(PatientConsentContext);

  // Determine if privacy policy should be shown.
  // (and if so, only after PatientConsent is submitted, or not needed)
  const shouldShowPrivacy =
    !loading &&
    !hasPrivacyPolicyAgreement &&
    !isLoadingConsentStatus &&
    (!requiresConsentSubmission || patientConsentSubmitted);

  const onAcceptancePrivacy = async (data: OnAcceptanceFields) => {
    const agreement = await acceptUserAgreement(data);
    setAgreements((prev) => [...prev, agreement]);
  };

  return (
    <>
      {<PatientConsent setPatientConsentSubmitted={setPatientConsentSubmitted} />}

      {shouldShowPrivacy && <PrivacyPolicyDialog onAcceptance={onAcceptancePrivacy} />}
    </>
  );
};
